/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keen_Low_Mongoose_FoldInputs */

const fr_keen_low_mongoose_fold = /** @type {(inputs: Keen_Low_Mongoose_FoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter/Retirer des packs a l'utilisateur`)
};

/**

* @param {Keen_Low_Mongoose_FoldInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const keen_low_mongoose_fold = /** @type {((inputs?: Keen_Low_Mongoose_FoldInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keen_Low_Mongoose_FoldInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_keen_low_mongoose_fold(inputs)
});